import { App } from 'vue'
import {Tabs, Tab} from 'vue3-tabs-component'

export default {
  install(app: App<Element>) {
    app.component('ui-tabs', Tabs)
    app.component('ui-tab', Tab)
  }
}
